import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {determinarPaginaAtual} from '../../actions/interessado-promocao/usuariosPromocaoActions'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoInteressados extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.interessadoPromocao.paginaAtual,
    total: state.interessadoPromocao.total,
    registrosPorPagina: state.interessadoPromocao.registrosPorPagina
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoInteressados)
